import { apiInitialState } from '../../../utils/apiStateUtils';

export default{
    userProjectsListApi: apiInitialState(),
    userProjectsList:null,
};